import HeaderHome from './layouts/HeaderHome';
import { codalyUrl, DesignerShowcase, PlatformCards, ArrowIcon } from './codaly/CodalyPromo';

const MEDIUM = 'landing';

/* Comparativa web2barcode vs Codaly */
const COMPARISON = [
    ['Diseñador visual de etiquetas',           false, true],
    ['Impresión ZPL',                           true,  true],
    ['Impresión TSPL y ESC/POS',                false, true],
    ['App web, iOS, Android y escritorio',      false, true],
    ['Actualización de precios en tiempo real', false, true],
    ['Verificador de precios',                  false, true],
    ['Catálogos / bases de datos',              true,  true],
    ['Gestión de usuarios',                     true,  true],
];

const Main = ({setCuenta}) => {

/*******************************************************************************************/
    return (
    <div className='principal'>

        <HeaderHome
            setCuenta={setCuenta}
        />

        <div className="cdl cdl-landing" style={{marginTop: '8.5rem'}}>
            <div className="container">

                {/* Hero: diseñador de Codaly en grande */}
                <section className="cdl-hero">
                    <div className="cdl-badge">
                        <span className="cdl-dot" /> Nuevo diseñador de etiquetas
                    </div>

                    <h1 className="cdl-title">
                        <span className="cdl-strike">web2 barcode</span>
                        Diseña e imprime tus etiquetas en{' '}
                        <span className="cdl-highlight">Codaly</span>
                    </h1>

                    <p className="cdl-subtitle">
                        web2barcode evolucionó. Codaly es su sucesor: un diseñador visual de etiquetas
                        en web, móvil y escritorio, con impresión directa y precios en tiempo real.
                    </p>

                    <div className="cdl-actions">
                        <a href={codalyUrl('/designer', MEDIUM)} target="_blank" rel="noopener noreferrer" className="cdl-btn cdl-btn-primary cdl-btn-lg cdl-pulse">
                            Abrir el diseñador de Codaly <ArrowIcon />
                        </a>
                        <a href={codalyUrl('/auth/register', MEDIUM)} target="_blank" rel="noopener noreferrer" className="cdl-btn cdl-btn-outline cdl-btn-lg">
                            Crear cuenta gratis
                        </a>
                    </div>

                    <button type="button" className="cdl-link-muted" onClick={() => setCuenta(1)}>
                        ¿Aún necesitas web2barcode? Iniciar sesión aquí
                    </button>

                    <DesignerShowcase medium={MEDIUM} />
                </section>

                {/* Diseñadores: web, móvil y escritorio */}
                <section className="cdl-section">
                    <div className="cdl-label">Un diseñador, tres plataformas</div>
                    <h2 className="cdl-section-title">Diseña donde estés</h2>
                    <p className="cdl-section-sub">
                        Tus etiquetas se sincronizan entre la web, tu celular y tu computadora.
                    </p>
                    <PlatformCards medium={MEDIUM} />
                </section>

                {/* Comparativa */}
                <section className="cdl-section pt-0">
                    <div className="cdl-label">Por qué migrar</div>
                    <h2 className="cdl-section-title">web2barcode vs Codaly</h2>
                    <p className="cdl-section-sub">Todo lo que ya usas, y mucho más.</p>

                    <div className="cdl-compare">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>web2barcode</th>
                                    <th className="cdl-col-codaly">Codaly</th>
                                </tr>
                            </thead>
                            <tbody>
                                {COMPARISON.map(([feature, w2b, codaly]) => (
                                    <tr key={feature}>
                                        <td>{feature}</td>
                                        <td>{w2b ? <span className="cdl-yes">✓</span> : <span className="cdl-no">✕</span>}</td>
                                        <td className="cdl-col-codaly">{codaly ? <span className="cdl-yes">✓</span> : <span className="cdl-no">✕</span>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* CTA final */}
                <section className="pb-5">
                    <div className="cdl-cta">
                        <h2>Migra hoy mismo a Codaly</h2>
                        <p>Más potente, mayor control y diseño de etiquetas personalizado.</p>
                        <div className="cdl-actions">
                            <a href={codalyUrl('/designer', MEDIUM)} target="_blank" rel="noopener noreferrer" className="cdl-btn cdl-btn-primary cdl-btn-lg">
                                Abrir el diseñador de Codaly <ArrowIcon />
                            </a>
                        </div>
                    </div>
                </section>

                {/* Ayuda */}
                <section className="pb-5">
                    <div className="cdl-help">
                        <h3 style={{ fontWeight: 700, marginBottom: '0.5rem' }}>¿Necesitas ayuda?</h3>
                        <p style={{ color: 'var(--cdl-muted)', marginBottom: '1.5rem' }}>
                            Nuestro centro de soporte está disponible para resolver cualquier duda.
                        </p>
                        <a href="https://ayuda.labeldictate.com" target="_blank" rel="noopener noreferrer" className="cdl-btn cdl-btn-outline">
                            Centro de ayuda →
                        </a>
                    </div>
                </section>
            </div>
        </div>

        <footer className="mt-auto py-4 bg-dark box-sh">
            <div className="container">
                <div className="d-flex justify-content-between">
                    <div className="text-white text-center w-100">
                        <p className="m-0">© Copyright <strong>Label Dictate Latam S.A. de C.V.</strong> Todos los derechos reservados.</p>
                        <p className="m-0 text-muted">Independencia 1018 I-201, Parques del Bosque, Tlaquepaque, Jalisco, México. 45609</p>
                        <span className="text-muted">
                            Diseñado por <a href="/" className="link-secondary">Label Dictate Latam S.A. de C.V</a>
                        </span>
                        <p className="text-muted m-0">
                            <a href="https://labeldictate.com/?c=privacy" className="link-secondary">Privacy Policy</a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
  )
}

export default Main
